<template>
    <layout :title="`Contract Details: ${invoices[0].contract_number}`">
        <div class="flex justify-end -mt-4 mb-2 w-full">
            <a :href="`/contract-details/${invoices[0].contract_number}/export`" class="flex items-center justify-center text-sm text-blue-600">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                <span>Export to CSV</span>
            </a>
        </div>
        <contract-detail-listings :invoices="invoices"></contract-detail-listings>
    </layout>
</template>

<script>

import Layout from "@/Shared/Layout";
import ContractDetailListings from "@/Components/CottonseedPayments/ContractDetailListings";

export default {
    components: {ContractDetailListings, Layout},
    props: {
        invoices: {
            type: Array,
            default: []
        },
    },
}
</script>
